<template>
  <div id="app">
    <MapContainer class="map" :map="map">
      <MapPoint :lng="item.longitude" :lat="item.latitude" v-for="(item, index) in list" :key="index">
        <div class="inner" @click="handleClick(item)">
          <img src="@/assets/map/map-icon.png" style="width: 21px;height: 29px;margin-top: -12px;margin-left: 5px;" />
          <div class="text">{{item.name}}</div>
        </div>
      </MapPoint>
    </MapContainer>
  </div>
</template>

<script>
  import MapContainer from './MapContainer.vue';
  import MapPoint from './MapPoint.vue';
  import map from '@/assets/map/map2.png';


  export default {
    components: {
      MapContainer,
      MapPoint,
    },
    data() {
      return {
        points: [
          { lng: 106.552528, lon: 106.552528, lat: 28.791279, name: '九九农家乐' },
          { lng: 106.602437, lon: 106.602437, lat: 28.848603, name: '食尚农家乐' },
        ],
        map
      };
    },
    props: {
      list: {
        type: Array,
        default: []
      },
    },
    created() {
      console.log('农家乐列表', this.list)
    },
    mounted() {


    },
    methods: {
      handleClick(item) {
        // console.log(item)
        this.$emit('handleClickMap', item)
      }
    }
  };
</script>

<style scoped>
  .map {
    margin: auto;
    width: 699px;
    height: 754px;
    /* background: url(@/assets/map.png) center / 630px 580px; */
  }

  .inner {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    /* background: red; */
    flex: none;
    position: relative;
    cursor: pointer;

    .text {
      position: absolute;
      top: -35px;
      left: 50%;
      display: block;
      width: 200px;
      margin-left: -100px;
      text-align: center;
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
</style>